import React from "react"
import gql from "graphql-tag"

import {Query as QueryComponent} from "../"


export const count = gql`
 query ScheduleList(
    $tenant: String!,
    $orderBy: String,
    $orderDirection: String
  ) {
    active: schedules(tenant: $tenant, orderBy: $orderBy, orderDirection: $orderDirection, status: null, limit: 1){
      total
    }
    archived: schedules(tenant: $tenant, orderBy: $orderBy, orderDirection: $orderDirection, status: "archived", limit: 1){
      total
    }
  }
`

const SchedulesCountQuery = (props) => <QueryComponent {...props} query={count} />

export default SchedulesCountQuery
